export default __webpack_public_path__ + "static/media/White Sox.44e2e209.png";